/**
 * Iterable Embedded Messaging — placement IDs.
 *
 * Placements are registered ahead of time in the Iterable admin UI by Marketing
 * Ops. Engineering receives a numeric ID per placement, which is what the
 * Embedded SDK keys content by.
 *
 * IDs differ per Iterable instance (staging vs. production), so they are
 * sourced from environment variables in `@m/config/env`. When an ID is not
 * configured for the current environment, the placement is excluded from the
 * sync list and its components render `null` (no eligible message).
 */
import {
  ITERABLE_DASHBOARD_HERO_PLACEMENT_ID,
  ITERABLE_RECEIPT_HERO_PLACEMENT_ID,
} from '@m/config/env';

export const DASHBOARD_HERO_PLACEMENT_ID = ITERABLE_DASHBOARD_HERO_PLACEMENT_ID;
export const RECEIPT_HERO_PLACEMENT_ID = ITERABLE_RECEIPT_HERO_PLACEMENT_ID;

export const EMBEDDED_PLACEMENT_IDS: number[] = [
  DASHBOARD_HERO_PLACEMENT_ID,
  RECEIPT_HERO_PLACEMENT_ID,
].filter((id): id is number => typeof id === 'number');
